import React from 'react';

function WindowsMailIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
            <path fill="#0078D4" d="m64 160 192-96 192 96v224H64V160z" />
            <path fill="#1A8DF7" d="M64 384V160l192 144 192-144v224H64z" />
            <path fill="#60b3ff" d="m448 159.996-191.984 144 191.972 79.992z" />
            <path fill="#e6e6e6" d="m96.007 183.997 160 120 160-120v-16h-320Z" />
        </svg>
    );
}

export default WindowsMailIcon;
